import { idsMatch } from 'flavours/glitch/compare_id';
import { inlineReplies } from 'flavours/glitch/initial_state';

export function isInlineReplyComposeActive(state) {
  return Boolean(
    inlineReplies &&
    state.getIn(['compose', 'in_reply_to']) !== null &&
    !state.getIn(['compose', 'reply_in_panel'])
  );
}

export function isComposingInlineReplyToStatus(state, statusId) {
  return Boolean(
    isInlineReplyComposeActive(state) &&
    statusId &&
    idsMatch(state.getIn(['compose', 'in_reply_to']), statusId)
  );
}
